import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { OktaService } from 'src/app/services/okta.service';

@Component({
  selector: 'app-unsaved-configuration-modal',
  templateUrl: './unsaved-configuration-modal.component.html',
  styleUrls: ['./unsaved-configuration-modal.component.scss'],
  standalone: false
})
export class UnsavedConfigurationModalComponent  implements OnInit {
closeLogin() {
throw new Error('Method not implemented.');
}

  constructor(private modalController: ModalController) { }

  ngOnInit() {}

  cancel() {
    this.modalController.dismiss(null, 'cancel');
  }

  next() {
  }

  dismiss() {
    this.modalController.dismiss(null, 'dismiss');
  }

}
